import { render } from "./DropdownFundRaisingRounds.vue?vue&type=template&id=2dbbc55e"
import script from "./DropdownFundRaisingRounds.vue?vue&type=script&lang=ts"
export * from "./DropdownFundRaisingRounds.vue?vue&type=script&lang=ts"
script.render = render

export default script